import { AxiosPromise } from "axios";
import { CONSTANT_CONFIG } from "../../constants";
import { HttpService } from "../../services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.LIBRARY_SERVER_PREFIX}/cataloguing`;
const endpoints = {
  list: () => `${RESOURCE_ENDPOINT}`,
  getById: (id: any) => `${RESOURCE_ENDPOINT}/${id}`,
  getByWhere: () => `${RESOURCE_ENDPOINT}/getByWhere`,
  create: () => `${RESOURCE_ENDPOINT}`,
  update: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
  updatePartial: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
  delete: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
  bulk: () => `${RESOURCE_ENDPOINT}/bulk`,
  dropdown: () => `${RESOURCE_ENDPOINT}/dropdown`,
  copy: () => `${RESOURCE_ENDPOINT}/copy`,
  updatePrivateStatus: () => `${RESOURCE_ENDPOINT}/updatePrivateStatus`,
  marc21View: () => `${RESOURCE_ENDPOINT}/marc-view`,
  handleMarc21Xml: () => `${RESOURCE_ENDPOINT}/marc-xml`,
  handleMarc21Unicode: () => `${RESOURCE_ENDPOINT}/marc-unicode`,
  getSearchCatalogueForLibrary: () => `${RESOURCE_ENDPOINT}/getSearchCatalogueForLibrary`,
}

export default class CataloguingApi {
  public list = (params = {}, headers = {}): AxiosPromise<any> => {
    const url = endpoints.list();
    return HttpService.get(url, params, headers);
  }

  public getById = (id: any): AxiosPromise<any> => {
    const url = endpoints.getById(id);
    return HttpService.get(url);
  }

  public getByWhere = (params = {}, headers = {}): AxiosPromise<any> => {
    const url = endpoints.getByWhere();
    return HttpService.get(url, params, headers);
  }

  public create = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
    const url = endpoints.create();
    return HttpService.post(url, payload, params, headers);
  }

  public update = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
    const url = endpoints.update(id);
    return HttpService.put(url, payload, params, headers);
  }

  public updatePartial = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
    const url = endpoints.updatePartial(id);
    return HttpService.patch(url, payload, params, headers);
  }

  public delete = (id: any, params = {}, headers = {}): AxiosPromise<any> => {
    const url = endpoints.delete(id);
    return HttpService.delete(url, params, headers);
  }

  public bulk = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
    const url = endpoints.bulk();
    return HttpService.post(url, payload, params, headers);
  }

  public dropdown = (params = {}, headers = {}): AxiosPromise<any> => {
    const url = endpoints.dropdown();
    return HttpService.get(url, params, headers);
  }

  public updatePrivateStatus = (params = {}, headers = {}): AxiosPromise<any> => {
    const url = endpoints.updatePrivateStatus();
    return HttpService.get(url, params, headers);
  }

  public copy = (params = {}, headers = {}): AxiosPromise<any> => {
    const url = endpoints.copy();
    return HttpService.get(url, params, headers);
  }

  public marc21View = (params = {}, headers = {}): AxiosPromise<any> => {
    const url = endpoints.marc21View();
    return HttpService.get(url, params, headers);
  }

  public handleMarc21Xml = (params = {}, headers = {}): AxiosPromise<any> => {
    const url = endpoints.handleMarc21Xml();
    return HttpService.get(url, params, headers);
  }

  public handleMarc21Unicode = (params = {}, headers = {}): AxiosPromise<any> => {
    const url = endpoints.handleMarc21Unicode();
    return HttpService.get(url, params, headers);
  }

  public getSearchCatalogueForLibrary = (params = {}, headers = {}): AxiosPromise<any> => {
    const url = endpoints.getSearchCatalogueForLibrary();
    return HttpService.get(url, params, headers);
  }

}
